import { render, staticRenderFns } from "./ManageWorkflowRoutes.vue?vue&type=template&id=c4b39314&scoped=true"
import script from "./ManageWorkflowRoutes.vue?vue&type=script&lang=js"
export * from "./ManageWorkflowRoutes.vue?vue&type=script&lang=js"
import style0 from "./ManageWorkflowRoutes.vue?vue&type=style&index=0&id=c4b39314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b39314",
  null
  
)

export default component.exports